export default {"src":"/_next/static/media/mastercard.0b583747.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};